<template>
    <div>
        <div class="mb-3 pb-3" style="border-bottom: 1px solid #949494">
            <div>
                <h5>
                    {{ this.$t('managerForm.settingPage.basicSettings') }}
                </h5>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-sm-2">
                <label class="text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.answerColumn') }} </label>
                <div class="my-3">
                    <button type="button" class="btn text-nowrap return__edit_with_editor" @click="handleToggleEditor">
                        {{ !isActiveEditor ? $t('managerForm.settingPage.editWithEditor') : $t('managerForm.settingPage.previewDisplay') }}
                    </button>
                </div>
                <div>
                    <p class="btn text-nowrap return__restore--default--settings mb-0" @click="handleRestoreDefaultSettings">
                        <i class="fa fa-undo" aria-hidden="true"></i>
                        {{ $t('managerForm.settingPage.restoreDefaultSettings') }}
                    </p>
                </div>
            </div>

            <div
                class="col-sm-10"
                :style="`overflow-x: ${![ALL_BLOCK_TYPE.BLOCK_SELECT, ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE, ALL_BLOCK_TYPE.BLOCK_DATE].includes(formBlock.block_type) ? 'auto' : ''}`"
            >
                <div v-if="!isActiveEditor">
                    <CommonOption
                        v-if="
                            [
                                ALL_BLOCK_TYPE.BLOCK_RADIO,
                                ALL_BLOCK_TYPE.BLOCK_SELECT,
                                ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
                                ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                            ].includes(formBlock.block_type)
                        "
                        :inforBlock="formBlock"
                        :configBlock.sync="configBlockPrev"
                        :formDefault.sync="formDefaultPrev"
                    />
                    <CommonText
                        v-if="
                            [
                                ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
                                ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
                                ALL_BLOCK_TYPE.BLOCK_INPUT,
                                ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                                ALL_BLOCK_TYPE.BLOCK_DATE,
                                ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                                ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                                ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                            ].includes(formBlock.block_type)
                        "
                        :inforBlock="formBlock"
                        :configBlock.sync="configBlockPrev"
                        :formDefault.sync="formDefaultPrev"
                    />

                    <div class="d-flex" style="gap: 15px">
                        <span>{{ $t('managerForm.settingPage.noteReset') }}</span>
                        <span v-if="isShowSetDefault" class="btn p-0" @click="handleSetValueDefault" style="color: #339162"
                            ><u>{{ $t('managerForm.settingPage.uncheckRadioButton') }} </u>
                        </span>
                    </div>
                </div>

                <div v-else>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.positionLeftNoteBlock') }}
                        </label>
                        <div class="col-sm-10">
                            <Editor
                                :id="`managerForm_settingPage_left_note_block`"
                                :model.sync="formBlock.additional_setting.note_left_block"
                                :configError.sync="configFormInput.configFieldLeftBlock"
                                :configInit="{ height: '300px' }"
                                @change="handleValidateField(configFormInput.configFieldLeftBlock)"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.positionRightNoteBlock') }}
                        </label>
                        <div class="col-sm-10">
                            <Editor
                                :id="`managerForm_settingPage_right_note_block`"
                                :model.sync="formBlock.additional_setting.note_right_block"
                                :configError.sync="configFormInput.configFieldRightBlock"
                                :configInit="{ height: '300px' }"
                                @change="handleValidateField(configFormInput.configFieldRightBlock)"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingPage.positionBottomNoteBlock') }}
                        </label>
                        <div class="col-sm-10">
                            <Editor
                                :id="`managerForm_settingPage_bottom_note_block`"
                                :model.sync="formBlock.additional_setting.note_bottom_block"
                                :configError.sync="configFormInput.configFieldBottomBlock"
                                :configInit="{ height: '300px' }"
                                @change="handleValidateField(configFormInput.configFieldBottomBlock)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isActiveTableMess" class="form-group row pt-3 border-top-1-color">
            <div class="col-sm-2">
                <label class="text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingPage.errorMessage') }} </label>
            </div>

            <div class="col-sm-10">
                <div v-if="!isTableErrorMsg">
                    <button type="button" class="btn text-nowrap return__edit_with_editor" @click="handleToggleErrorMsg">
                        {{ $t('managerForm.settingPage.editErrorMessage') }}
                    </button>
                    <p class="mt-3">{{ $t('managerForm.settingPage.noteEditErrorMessage') }}</p>
                </div>
                <div v-else>
                    <h4 class="text-center mb-3" style="font-weight: 600">{{ $t('managerForm.settingPage.titleEditMessError') }}</h4>
                    <div v-if="!isErrorInputMess" class="errormessage">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <p>{{ $t('managerForm.settingPage.errorMsgInput') }}</p>
                    </div>
                    <p class="mt-3">{{ $t('managerForm.settingPage.noteSettingMess') }}</p>
                    <table class="table table-bordered">
                        <thead>
                            <th
                                v-for="(item, k) in TABLE_ERROR_MESSAGES.headers"
                                :key="k"
                                style="background: #ededed"
                                :style="`min-width: ${item.width}px`"
                            >
                                <div class="d-flex align-items-center">
                                    {{ item.label }} <span v-if="item.required" class="text-danger ml-2">*</span>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="(msgItem, idx) in listMessages" :key="`tr-msg-${idx}`">
                                <td v-if="msgItem.action.includes(formBlock.block_type) && onHandleConditionEachMessage(msgItem)">
                                    <div>{{ msgItem.label }}</div>
                                </td>
                                <td v-if="msgItem.action.includes(formBlock.block_type) && onHandleConditionEachMessage(msgItem)">
                                    <div>
                                        <InputText
                                            :model.sync="msgItem.messages"
                                            :config.sync="configFormInput.validateArrayErrMsg[idx].configFieldErrorMsg"
                                            @blur="handleValidateField(configFormInput.validateArrayErrMsg[idx].configFieldErrorMsg)"
                                        />
                                    </div>
                                </td>
                                <td v-if="msgItem.action.includes(formBlock.block_type) && onHandleConditionEachMessage(msgItem)">
                                    <div>
                                        <button class="restore-default-error-msg text-nowrap" @click="handleRestoreDefaultErrorMsg(idx)">
                                            {{ $t('managerForm.settingPage.restoreDefaultSettings') }}
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="d-flex justify-content-center">
                        <button type="button" class="btn btn-light text-nowrap" @click="handleCancelErrorMsg">
                            {{ $t('managerForm.settingPage.buttonType.cancelSettingMessages') }}
                        </button>
                        <button type="button" class="btn btn-success text-nowrap ml-3" @click="handleSaveErrorMsg">
                            {{ $t('managerForm.settingPage.buttonType.saveSettingMessages') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { validateField, validateAllField } from '@/utils/validate';
import { TABLE_ERROR_MESSAGES, CONFIG_FIELD_OPTION_PREV, VALUE_DEFAULT_BLOCK, OPTION_YES_NO, OPTION_FORMAT_DATE } from '../constants';
import { InputText } from '@/components/Input';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { FORMAT_VALUE_PHONE } from '../../../handlers';
import { generateYearList, MONTH_OPTIONS, DAY_OPTIONS, isShowDateFormType } from '../../../iframe-page/handlers';

import _ from 'lodash';
import CommonOption from './prev-common-option.vue';
import CommonText from './prev-common-text.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'AdditionalSettings',
    props: {
        formBlock: {
            type: Object,
            required: true,
            default: () => null
        },
        configFormInput: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    components: {
        Editor,
        InputText,
        CommonOption,
        CommonText
    },
    data() {
        return {
            isActiveEditor: false,
            isTableErrorMsg: false,
            isSaveSettingBlock: false,
            isErrorInputMess: true,
            TABLE_ERROR_MESSAGES: TABLE_ERROR_MESSAGES,
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            listErrorMessagesCopy: [],
            listMessages: _.cloneDeep(this.$store.state.managerForm.listMessageBlocks),
            getBlockType: this.formBlock.block_type,
            configBlockPrev: CONFIG_FIELD_OPTION_PREV(this.formBlock),
            formDefaultPrev: VALUE_DEFAULT_BLOCK(this.formBlock)
        };
    },

    computed: {
        isActiveTableMess() {
            let { order_required, block_checkbox, setting_others } = this.formBlock;
            let active = false;

            if (this.getBlockType !== ALL_BLOCK_TYPE.BLOCK_INPUT && order_required) {
                active = true;
            }

            switch (this.getBlockType) {
                case ALL_BLOCK_TYPE.BLOCK_INPUT:
                case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                case ALL_BLOCK_TYPE.BLOCK_DATE:
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    active = true;
                    break;
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    active =
                        order_required ||
                        block_checkbox.operator_limit_check ||
                        block_checkbox.number_limit_check ||
                        setting_others?.uncheck_use ||
                        setting_others.value_other_required;
                    break;
            }

            return active;
        },

        isShowSetDefault() {
            return ![
                ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                ALL_BLOCK_TYPE.BLOCK_SELECT,
                ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                ALL_BLOCK_TYPE.BLOCK_INPUT,
                ALL_BLOCK_TYPE.BLOCK_DATE,
                ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
                ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX
            ].includes(this.formBlock.block_type);
        }
    },

    methods: {
        handleBackStep1() {
            this.$emit('back', true);
        },

        handleSaveSettingBlock() {
            this.handleMapMessages();
            this.onHandleSetValueDefaultBlock();
            this.$emit('save', false);
        },

        handleToggleEditor() {
            this.isActiveEditor = !this.isActiveEditor;
        },

        handleRestoreDefaultSettings() {
            this.formBlock.additional_setting.note_left_block = '';
            this.formBlock.additional_setting.note_right_block = '';
            this.formBlock.additional_setting.note_bottom_block = '';
            this.formDefaultPrev = VALUE_DEFAULT_BLOCK(this.formBlock);
        },

        handleSetValueDefault() {
            this.formDefaultPrev.choiceValue = '';
            this.formDefaultPrev.choiceValues = [];
        },

        handleValidateField(configField) {
            validateField(configField);
        },

        handleToggleErrorMsg() {
            this.isTableErrorMsg = !this.isTableErrorMsg;
            this.isSaveSettingBlock = !!this.isTableErrorMsg;
            if (this.isTableErrorMsg) {
                this.listErrorMessagesCopy = _.cloneDeep(this.listMessages);
            }
        },

        handleRestoreDefaultErrorMsg(index) {
            this.listMessages[index].messages = this.listMessages[index].msg_default;
        },

        handleCancelErrorMsg() {
            this.configFormInput.validateArrayErrMsg = this.configFormInput.validateArrayErrMsg.map((err) => {
                return {
                    configFieldErrorMsg: {
                        ...err.configFieldErrorMsg,
                        error: false
                    }
                };
            });
            this.listMessages = this.listErrorMessagesCopy;
            this.isErrorInputMess = true;
            this.handleToggleErrorMsg();
        },

        handleSaveErrorMsg() {
            let checkError = validateAllField(this.configFormInput.validateArrayErrMsg);
            this.isErrorInputMess = this.checkMessagePlaceholderMismatch(this.listMessages);
            if (!checkError || !this.isErrorInputMess) return;
            this.handleMapMessages();
            this.handleToggleErrorMsg();
        },

        handleMapMessages() {
            this.formBlock.additional_setting.error_message_block = this.listMessages.filter((msgItem) =>
                msgItem.action.includes(this.formBlock.block_type)
            );
        },

        onHandleConditionEachMessage(object) {
            return (
                this.isRequiredValueOther(object) &&
                this.handleMessForBlockInput(object) &&
                this.handleMessForBlockCheckbox(object) &&
                this.handleMessForBlockUploadFile(object) &&
                this.handleMessForBlockPostalCode(object) &&
                this.handleMessForBlockDate(object)
            );
        },

        isRequiredValueOther(object) {
            if (object.type_msg !== 'required_other') return true;
            let result = object.required_value_other == this.formBlock.setting_others.value_other_required;
            return result;
        },

        handleMessForBlockInput(object) {
            let result = true;
            if (![ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_FULL_NAME].includes(this.getBlockType)) return result;
            let { block_input, input_format, order_required } = this.formBlock;
            switch (object.type_msg) {
                case 'required':
                    result = object.required_input === order_required;
                    break;
                case 'character_range':
                    result = input_format?.type_input !== 'numeric_value_including_decimal_point' && input_format?.type_input !== 'numerical_value';
                    if (!block_input.minimum_number) {
                        result = false;
                    }
                    if (!block_input.maximum_number) {
                        result = false;
                    }
                    break;
                case 'format_numerical_value':
                    result = input_format?.type_input === 'numerical_value';
                    break;
                case 'age_condition':
                    result = input_format?.type_input === 'number';
                    break;
                case 'keyword_pattern':
                    result = block_input.confirm_input_twice === OPTION_YES_NO[0].id;
                    break;
                case 'duplicate':
                    result = block_input.duplicate_input === OPTION_YES_NO[0].id;
                    break;
                case 'maxlength_textarea':
                    result = !['numerical_value', 'numeric_value_including_decimal_point'].includes(input_format?.type_input);
                    if (block_input.minimum_number && block_input.maximum_number) {
                        result = false;
                    }
                    break;
                case 'email':
                case 'number':
                case 'half-width_alphanumeric_characters':
                case 'full-width_characters':
                case 'hiragana':
                case 'katakana':
                case 'full-width_katakana':
                case 'half-width_katakana':
                case 'numerical_value':
                case 'numeric_value_including_decimal_point':
                    result = object.type_msg == input_format?.type_input;
                    break;
            }
            return result;
        },

        handleMessForBlockUploadFile(object) {
            let { order_required, block_keyword_box } = this.formBlock;
            let result = true;
            if (![ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE, ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX].includes(this.getBlockType)) return result;
            switch (object.type_msg) {
                case 'required':
                    result = order_required;
                    break;
                case 'duplicate':
                    result =
                        this.getBlockType === ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX ? block_keyword_box?.duplicate_input === OPTION_YES_NO[0].id : result;
                    break;
            }
            return result;
        },
        handleMessForBlockPostalCode(object) {
            let { block_post_code } = this.formBlock;
            let result = true;
            if (![ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE].includes(this.getBlockType)) return result;
            switch (object.type_msg) {
                case 'zipcode_required':
                case 'address_not_found':
                    result = block_post_code.feature_search_address === OPTION_YES_NO[0].id;
                    break;
            }
            return result;
        },
        handleMessForBlockDate(object) {
            let { block_date, order_required } = this.formBlock;
            let result = true;
            if (![ALL_BLOCK_TYPE.BLOCK_DATE, ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER].includes(this.getBlockType)) return result;
            switch (object.type_msg) {
                case 'required':
                    result = order_required;
                    break;
                case 'character_input':
                    result = block_date.format_year.type === OPTION_FORMAT_DATE[0].id;
                    break;
            }
            return result;
        },

        handleMessForBlockCheckbox(object) {
            let { order_required, block_checkbox, setting_others } = this.formBlock;
            let result = true;
            if (this.getBlockType !== ALL_BLOCK_TYPE.BLOCK_CHECKBOX) return result;
            switch (object.type_msg) {
                case 'required':
                    result = object.required_checkbox === order_required;
                    break;
                case 'checked_quantity_error':
                    result = block_checkbox.operator_limit_check?.value === '≧' && block_checkbox.number_limit_check;
                    break;
                case 'exclusive_check_error':
                    result = setting_others.uncheck_use;
                    break;
            }
            return result;
        },

        onHandleSetValueDefaultBlock() {
            this.formBlock.default_choice = this.formDefaultPrev.choiceValue;
            this.formBlock.default_choices = this.formDefaultPrev.choiceValues;

            switch (this.formBlock.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    this.formBlock.value_default_text = `${this.formDefaultPrev.phoneValue_1}-${this.formDefaultPrev.phoneValue_2}-${this.formDefaultPrev.phoneValue_3}`;
                    break;
                case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                    if (this.formDefaultPrev.placeholderFirstName) {
                        this.formBlock.value_default_text = `${this.formDefaultPrev.placeholderFirstName}`;
                        if (this.formDefaultPrev.placeholderLastName) {
                            this.formBlock.value_default_text = `${this.formDefaultPrev.placeholderFirstName}-${this.formDefaultPrev.placeholderLastName}`;
                        }
                    }
                    if (this.formDefaultPrev.placeholderLastName) {
                        this.formBlock.value_default_text = `-${this.formDefaultPrev.placeholderLastName}`;
                        if (this.formDefaultPrev.placeholderFirstName) {
                            this.formBlock.value_default_text = `${this.formDefaultPrev.placeholderFirstName}-${this.formDefaultPrev.placeholderLastName}`;
                        }
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                    this.formBlock.value_default_text = `${this.formDefaultPrev.postcodeValue_1}-${this.formDefaultPrev.postcodeValue_2}`;
                    break;
                case ALL_BLOCK_TYPE.BLOCK_DATE:
                    if (
                        isShowDateFormType(this.formBlock.block_date.format_year.type, this.formBlock.block_date.format_month_day.type) ===
                        'inputDate'
                    ) {
                        const listYear = generateYearList(
                            this.formBlock.block_date.format_year.lower_limit,
                            this.formBlock.block_date.format_year.upper_limit,
                            this.formBlock.block_date.format_year.type_calendar
                        );
                        this.formBlock.value_default_text = this.formDefaultPrev.textValue;
                        if (this.formBlock.value_default_text) {
                            this.formBlock.block_date.select_value_default = {
                                year: listYear.find((year) => year.value == FORMAT_VALUE_PHONE(this.formBlock.value_default_text, 0)),
                                month: MONTH_OPTIONS.find((month) => month.value == FORMAT_VALUE_PHONE(this.formBlock.value_default_text, 1)),
                                day: DAY_OPTIONS.find((day) => day.value == FORMAT_VALUE_PHONE(this.formBlock.value_default_text, 2))
                            };
                        }
                    } else if (
                        isShowDateFormType(this.formBlock.block_date.format_year.type, this.formBlock.block_date.format_month_day.type) ===
                        'selectDate'
                    ) {
                        this.formBlock.block_date.select_value_default = {
                            year: this.formDefaultPrev.selectYear,
                            month: this.formDefaultPrev.selectMonth,
                            day: this.formDefaultPrev.selectDay
                        };
                        this.formBlock.value_default_text =
                            this.formDefaultPrev.selectYear?.value && this.formDefaultPrev.selectMonth?.value && this.formDefaultPrev.selectDay?.value
                                ? `${this.formDefaultPrev.selectYear.value}-${this.formDefaultPrev.selectMonth.value}-${this.formDefaultPrev.selectDay.value}`
                                : '';
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_INPUT:
                    if (this.formBlock.block_input.confirm_input_twice === OPTION_YES_NO[0]?.id) {
                        this.formBlock.value_default_text = `${this.formDefaultPrev.textValue}<<CONFIRMTEXT>>${this.formDefaultPrev.confirmTextValue}`;
                    } else {
                        this.formBlock.value_default_text = this.formDefaultPrev.textValue;
                    }
                    break;
                default:
                    this.formBlock.value_default_text = this.formDefaultPrev.textValue;
            }
        },

        onHandleChangeMessage() {
            let { block_input } = this.formBlock;
            const messInputMinMax = `{0}文字から{1}文字で入力してください。`;
            const messInputMax = `{0}文字以内で入力してください。`;

            this.listMessages = this.listMessages.map((item) => {
                if (item.type_msg === 'maxlength_textarea') {
                    const hasMin = !!block_input.minimum_number;
                    const hasMax = !!block_input.maximum_number;
                    if (hasMin && hasMax) {
                        item.msg_default = messInputMinMax;
                        item.messages = messInputMinMax;
                    } else if (!hasMin && hasMax) {
                        item.msg_default = messInputMax;
                        item.messages = messInputMax;
                    } else if (hasMin && !hasMax) {
                        item.label = '文字数範囲エラー';
                        item.msg_default = messInputMinMax;
                        item.messages = messInputMinMax;
                    } else {
                        item.msg_default = messInputMax;
                        item.messages = messInputMax;
                    }
                }
                return item;
            });
        },

        checkMessagePlaceholderMismatch(arrMess) {
            let errorCheck = true;
            for (let i = 0; i < arrMess.length; i++) {
                const { label, messages, msg_default } = arrMess[i];
                const fieldError = this.configFormInput.validateArrayErrMsg[i].configFieldErrorMsg;
                const extractPlaceholders = (str) => {
                    const matches = str.match(/{(.*?)}/g) || [];
                    return matches.map((p) => Number(p.replace(/[{}]/g, ''))).sort();
                };

                const originalPlaceholders = extractPlaceholders(msg_default);
                const modifiedPlaceholders = extractPlaceholders(messages);

                const isSame =
                    originalPlaceholders.length === modifiedPlaceholders.length &&
                    originalPlaceholders.every((val, idx) => val === modifiedPlaceholders[idx]);

                if (!isSame && fieldError.valueSync) {
                    fieldError.error = true;
                    fieldError.errorCustomMess = `${label}に使用できないタグがあります。`;
                    errorCheck = false;
                }
            }
            return errorCheck;
        }
    },
    mounted() {
        this.onHandleChangeMessage();
    }
};
</script>

<style lang="scss" scoped>
.return__edit_with_editor {
    background: #ffffff;
    border: solid 1px #339162;
    color: #339162;
    font-size: 13px;
    &:hover {
        opacity: 0.7;
    }
}

.return__restore--default--settings {
    color: #339162;
}

.border-top-1-color {
    border-top: 1px solid #0000001a;
}

.restore-default-error-msg {
    background: #ffffff;
    color: #339162;
    border: solid 1px #339162;
    padding: 9px 9px;
    border-radius: 2px;
}
.errormessage {
    display: flex;
    align-items: center;
    border: #ec9b9b 1px solid;
    padding: 5px 20px;
    margin: 30px 0 0 0;
    width: 100%;
    box-sizing: border-box;
    i {
        color: #ec9b9b;
        font-size: 25px;
    }
    p {
        margin: 12px 0 12px 10px;
        padding: 0;
        font-size: 12px;
        color: #ce4141;
        line-height: 24px;
        font-weight: 600;
    }
}
</style>
